<template>
  <el-container class="home container">
    <h2 class="headline align-left">Welcome to your e-learning website!</h2>
    <p class="body align-left">This platform was developed to support you in your SalesForce Marketing Cloud training, as part of the Marketing One-to-One project. <br>
    To that end, we divided your training in several modules, representing the different skills you should master.</p>
    <div class="loading" v-if="loading" key="1" v-loading="loading">
    </div>
    <transition-group name="fade" style="width: 100%">
      <div class="cards" :class="{'cards-loading' : loading}" key="2" v-if="modules.length > 0">
        <Card v-for="_module in modules" :key="_module.id" :card="_module" @click="openModule(_module)"/>
      </div>
    </transition-group>
  </el-container>
</template>

<script>
// @ is an alias to /src
import { GET_MODULES, GET_MODULE, GET_INFOS } from "@/store/api.js";
import Card from '@/components/lessons/Card'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    Card
  },
  data () {
    return {
      loading: true,
      error: ''
    }
  },
  computed: {
    ...mapGetters({
      modules: 'modules/list',
      email : 'user/email',
      lastLogin: 'user/lastLogin',
      requestedId: 'modules/requestedId'
    }),
    isOldToken () {
      if (this.lastLogin) {
        var loginDate = new Date(this.lastLogin)
        var today = new Date()
        var diff = Math.abs(today.getTime() - loginDate.getTime()) / 3600000;
        if (diff > 24) { /* do something */ 
          return true
        } else {
          return false
        }
      }
      return false
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.$store.commit('modules/SET_REQUESTED_ID', parseInt(this.$route.query.id))
    }
    if (!this.email) {
      if (this.$route.query.t && this.$route.query.t === 'welcome') {
        this.$router.push({name: 'new'})
      } else {
        this.$router.push({name: 'login'})
      }
    } else if (this.isOldToken) {
      this.$store.commit('user/reset')
      this.$store.commit('modules/reset')
      this.$router.push({name: 'login'})
    } else if (this.requestedId) {
      this.fetchRequestedModule()
    } else {
      this.fetchUserInfos()
      this.fetchModules()
    }
  },
  methods: {
    fetchUserInfos () {
      this.loading = true
      this.$apollo.query({
        query: GET_INFOS,
      })
      .then((result) => {
        this.loading = false
        if (result.errors && result.errors[0].message === 'login required') {
          this.$router.push({name: 'login'})
        } else {
          this.$store.commit('user/set_infos', result.data.user)
        }
      })
    },
    fetchModules () {
      this.loading = true
      this.$apollo.query({
        query: GET_MODULES,
      })
      .then((result) => {
        this.loading = false
        if (result.errors && result.errors[0].message === 'login required') {
          this.$router.push({name: 'login'})
        } else {
          this.$store.commit('modules/SET_MODULES', result.data.modules)
        }
      })
    },
    openModule (_module) {
      if (!this.loading) {
        this.loading = true
        this.$apollo.query({
          query: GET_MODULE(_module.id),
        })
        .then((result) => {
          this.loading = false
          if (result.errors && result.errors[0].message === 'login required') {
            this.$router.push({name: 'login'})
          } else {
            this.$store.commit('modules/SELECT_MODULE', result.data.module)
            this.$router.push({name: 'details', query: { id: result.data.module.id }}) 
          }
        })
      }
    },
    fetchRequestedModule () {
      this.$apollo.query({
          query: GET_MODULE(this.requestedId),
        })
        .then((result) => {
          this.loading = false
          if (result.errors && result.errors[0].message === 'login required') {
            this.$router.push({name: 'login'})
          } else {
            this.$store.commit('modules/SELECT_MODULE', result.data.module)
            this.$router.push({ name: 'details', query: { id: result.data.module.id }}) 
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles';
  .home {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    h2 {
      text-align: left;
      margin: 0;
    }
    span {
      width: 100%;
    }
    .cards {
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;
      justify-content: center;
      gap: 32px;
      width: 100%;
      margin-top: 20px;

      @media (min-width: 1366px) {
        grid-template-columns: auto auto auto;
      }

      &.cards-loading {
        opacity: .3;
       /deep/ .card {
          cursor: progress;
        }
      }
    }
    @media (max-width: 768px) {
      .cards {
        margin-top: 20px;
        justify-content: center;
      }
    }
  }

  .loading {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
</style>
